// The preview uses hundredths; exports retain the processor's millisecond precision.
export function clipTime(seconds: number): string {
  const hundredths = Math.round(Math.max(0, seconds) * 100);
  return `${Math.floor(hundredths / 6000)}:${((hundredths % 6000) / 100).toFixed(2).padStart(5, "0")}`;
}

export function validTrimSelection(startText: string, endText: string, duration: number): boolean {
  const start = Number(startText);
  const end = Number(endText);
  return startText.trim() !== "" && endText.trim() !== "" &&
    Number.isFinite(start) && Number.isFinite(end) && start >= 0 &&
    end <= 86400 && end - start >= 0.1 - 1e-9 &&
    (!duration || (start < duration && end <= duration + 0.005));
}

// Web Audio decodes the entire file even for a small waveform. Avoid that cost
// for long recordings; the media element and exact time fields still work.
export const MAX_WAVEFORM_SECONDS = 30 * 60;

export function canBuildWaveform(duration: number): boolean {
  return Number.isFinite(duration) && duration > 0 && duration <= MAX_WAVEFORM_SECONDS;
}
